import { Button, Dropdown } from "antd";
import React from "react";

interface ButtonDropdownProps {
	label: string;
	items: any;
	onClick?: (item?: any) => void;
	disabled?: boolean;
	placement?:
		| "bottom"
		| "bottomLeft"
		| "bottomRight"
		| "top"
		| "topLeft"
		| "topRight";
	buttonType?: "primary" | "default" | "text" | "link" | "dashed";
	icon?: React.ReactNode;
	iconPosition?: "start" | "end" | undefined;
}

function ButtonDropdown({
	label,
	items,
	onClick,
	disabled,
	placement,
	buttonType,
	icon,
	iconPosition,
}: ButtonDropdownProps) {
	return (
		<Dropdown
			disabled={disabled ?? false}
			menu={{
				items: items,
				onClick:
					onClick ??
					((item: any) => {
						console.log("default item clicked:", item);
					}),
			}}
			placement={placement ?? "bottomLeft"}
		>
			<Button
				iconPosition={iconPosition}
				icon={icon}
				type={buttonType ?? "default"}
				style={{ padding: "0px" }}
			>
				{label}
			</Button>
		</Dropdown>
	);
}

export default ButtonDropdown;
